import {
  ChangeDetectionStrategy,
  AfterViewInit,
  Component,
} from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "audio-error-404",
  templateUrl: "./error-404.component.html",
  styleUrls: ["./error-404.component.sass"],
  imports: [RouterLink],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error404Component implements AfterViewInit {
  ngAfterViewInit = () => {
    throw new Error("Test Sentry");
  };
}
